// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"204":"7779da186bc2326b","535":"b4aa2a2eb8b405bf","767":"a07b879460d88795","945":"46950272453c14d5"}[chunkId] + ".js";
};